import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').MedicalPatient} MedicalPatient
 */

/**
 * @param {State} state
 * @param {MedicalPatient[]} obj
 */
export function setPatients (state, obj) {
  state.patients = obj || [];
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {MedicalPatient[]} obj.items
 */
export function updateInPatients (state, obj) {
  const { items, upsert } = obj;
  const list = state.patients;
  items.forEach(item => {
    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing
    if (~index) {
      return Vue.set(list, index, item);
    }

    // add to list
    if (upsert) list.push(item);
  });
}
